<template>
    <div
        v-if="$store.state.policy.activityCode !== 'ESUN'"
        class="z-50 h-20 relative bg-white"
    >
        <div class="z-50 border-b border-gray-350 fixed w-full xl:block">
            <div class="main-head-bar-xl h-4 flex justify-end items-center">
                <img
                    src="@/assets/images/Group.png"
                    alt="to be a good company"
                    loading="lazy"
                    class="h-3"
                >
                <img
                    src="@/assets/images/wave.png"
                    alt="新安東京海上產險"
                    loading="lazy"
                    class="h-2 self-end"
                >
            </div>
            <div class="bg-white hidden xl:flex h-16 justify-between items-center px-2 xl:px-8 mx-auto">
                <a
                    data-accuid="Head_Logo"
                    href="https://www.tmnewa.com.tw/ec/#/"
                    class="logo cursor-pointer"
                ></a>
                <div class="flex items-end space-x-5">
                    <router-link
                        data-accuid="Head_Home"
                        :to="`/${$route.params.type}`"
                        class="hidden xl:block"
                    >
                        <div class="h-10 flex items-center">
                            <div
                                title="回商品頁"
                                class="text-black"
                            >
                                回商品頁
                            </div>
                        </div>
                    </router-link>
                    <div>
                        <div
                            class="h-10 flex items-center cursor-pointer"
                            :class="{'bg-gray-100': $store.state.showSubmenu}"
                            @click="toggleSubmenu"
                        >
                            <div
                                data-accuid="Head_Nav"
                                title="更多"
                                class="w-6 h-6 py-0.5"
                            >
                                <IconMenu />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Submenu More -->
        <div
            v-show="$store.state.showSubmenu"
            class="bg-black-50 max-h-screen h-screen fixed top-0 w-full z-48 overflow-hidden"
            @click.self="toggleSubmenu"
        >
            <div class="text-[18px] leading-4 fixed right-0 top-16 text-left bg-white p-10 text-black-800 h-screen">
                <div class="py-4">
                    <a
                        data-accuid="Nav_Lookup"
                        :href="memberUrl"
                    >
                        投保後查詢
                    </a>
                </div>
                <div class="py-4">
                    <router-link
                        data-accuid="Nav_Renewal"
                        :to="`/${$route.params.type}/renewal`"
                    >
                        續保登入
                    </router-link>
                </div>
                <div class="py-4">
                    <router-link
                        :to="`/${$route.params.type}/plan`"
                    >
                        試算單登入
                    </router-link>
                </div>
                <div
                    data-accuid="Nav_Doc"
                    class="py-4 flex justify-between cursor-pointer"
                    @click.stop="isDownloadButtonActive = !isDownloadButtonActive"
                >
                    文件下載
                    <button>
                        <component
                            :is="isDownloadButtonActive ? 'IconChevronUp' : 'IconChevronDown'"
                            class="w-4 h-4"
                        />
                    </button>
                </div>
                <ul
                    v-show="isDownloadButtonActive"
                    class="text-[16px]"
                >
                    <li class="py-4">
                        <a
                            data-accuid="Nav_Epolicy"
                            href="https://www.tmnewa.com.tw/B2C_V2/commonweb/epolicy.aspx"
                            target="_blank"
                        >
                            電子保單
                        </a>
                    </li>
                    <li class="py-4">
                        <a
                            data-accuid="Nav_Certificatequery"
                            href="https://www.tmnewa.com.tw/b2c_v2/frontstage/certificatequery.aspx"
                            target="_blank"
                        >電子式強制證</a>
                    </li>
                    <li class="py-4">
                        <a
                            data-accuid="Nav_Download"
                            href="https://www.tmnewa.com.tw/b2c_v2/frontstage/download.aspx"
                            target="_blank"
                        >批改申請書</a>
                    </li>
                </ul>
                <div class="py-4">
                    <a
                        data-accuid="Nav_ProductIntro"
                        :href="`https://www.tmnewa.com.tw/product/intro/${$route.params.type == 'car' ? '1' : '8'}`"
                        target="_blank"
                    >
                        商品說明
                    </a>
                </div>
                <div class="py-4">
                    <router-link
                        data-accuid="Nav_Faq"
                        :to="`/${$route.params.type}/faq`"
                    >
                        常見問題
                    </router-link>
                </div>
                <div class="py-4">
                    <a
                        data-accuid="Nav_Member"
                        :href="memberUrl"
                        target="_blank"
                    >
                        會員專區
                    </a>
                </div>
                <!-- <div class="py-4">
                    <a
                        data-accuid="Nav_Client"
                        href="https://ecchat.tmnewa.com.tw/client/client.html"
                        target="_blank"
                    >
                        線上客服
                    </a>
                </div> -->
                <div class="py-4 text-[16px]">
                    <a
                        data-accuid="Nav_TMH"
                        href="https://www.tokiomarinehd.com/en/"
                        target="_blank"
                        class="flex gap-2"
                    >
                        Tokio Marine Holdings
                        <img
                            src="@/assets/images/global.png"
                            alt="Tokio Marine Holdings"
                            loading="lazy"
                            class="h-5 place-self-center"
                        >
                    </a>
                </div>
                <div class="py-4">
                    <div
                        v-if="$store.getters['auth/loggedIn']"
                        data-accuid="Nav_Logout"
                        class="cursor-pointer"
                        @click="logout"
                    >
                        [登出]
                    </div>
                    <router-link
                        v-else
                        data-accuid="Nav_Login"
                        :to="{ name: 'Login'}"
                        class="cursor-pointer"
                        @click="$store.commit('nav/setAll', { to: $route, from: $route, clear: true})"
                    >
                        [登入註冊]
                    </router-link>
                </div>
            </div>
        </div>
        <!--/ Submenu More -->

        <!-- 手機板header -->
        <div
            id="main-head"
            class="border-b border-gray-350 bg-white xl:hidden flex fixed top-4 w-full items-center justify-between px-2 py-1 h-16 text-black z-30"
        >
            <a
                data-accuid="Head_Logo"
                href="https://www.tmnewa.com.tw/ec/#/"
                class="logo cursor-pointer"
            ></a>
            <div class="flex items-center justify-end">
                <div
                    data-accuid="Head_Nav"
                    class="ml-3 h-10 flex items-center cursor-pointer"
                    @click="$store.commit('navigationDrawerToggle')"
                >
                    <IconMenu class="w-6 h-6" />
                </div>
            </div>
        </div>
        <!--/ 手機板header -->
    </div>
</template>

<script>
import IconMenu from '@/components/icons/Menu';
import IconChevronUp from '@/components/icons/ChevronUp';
import IconChevronDown from '@/components/icons/ChevronDown';
/**
 *  Header
 */
export default {
    name: 'MainHeader',
    components: {IconMenu, IconChevronDown, IconChevronUp},
    data() {
        /**
         *  @param {Boolean} showSubmenu 用於判斷更多選單開關
         *  @param {Boolean} isDownloadButtonActive 用於判斷文件下載開關
         */
        return {
            showSubmenu: false,
            isDownloadButtonActive: false,
            memberUrl: process.env.VUE_APP_MEMBER
        };
    },
    watch: {
        '$store.state.showSubmenu': {
            handler(value) {
                if (value) {
                    // 使 body 元素的內容禁止滾動，彈跳視窗顯示時，防止使用者通過滾動背景頁面造成網頁重新整理
                    document.body.classList.add('overflow-hidden');
                } else {
                    // body 元素的內容允許滾動
                    document.body.classList.remove('overflow-hidden');
                }
            },
        },
    },
    methods: {
        /**
         *  登出
         * 
         *  @public
         */
        logout() {
            this.$store.commit('showLoading');
            this.$store.commit('navigationDrawerClose');
            this.$store.commit('hideAllSubmenu');
            this.$auth.logout();
            this.$idle.stop();

            setTimeout(() => {
                this.$store.commit('closeLoading');
                this.$store.commit('setDialog', {
                    title: '登出成功',
                    type: 'logout',
                    text: '您已登出成功',
                    active: true
                });
            }, 500);

        },
        /**
         *  開關更多選單
         * 
         *  @public
         */
        toggleSubmenu() {
            this.$store.commit('toggleSubmenu');
        },
        /**
         *  開關更多選單
         *  @public
         */
        toggleSubmenuFromSubmenu() {
            if(!!this.showSubmenu && !!this.$store.state.showSubmenu){
                this.$store.commit('toggleSubmenu');
            }
            this.showSubmenu = this.$store.state.showSubmenu;
        },
    }
};
</script>

<style scoped>
#main-head {
    background-size: 100% auto;
}

.logo {
    width: 245px;
    max-width: 300px;
    height: 100%;
    min-height: 30px;
    background: url(../assets/images/logo.png) 0 center no-repeat;
    background-size: contain;
}

.main-head-bar-xl {
    width: 100%;
    background: linear-gradient(90deg,#00b3fe,#039);
}
</style>